// extracted by mini-css-extract-plugin
module.exports = {"description":"description-module__description___WYL8y","readMore":"description-module__readMore___iQkvl"};